import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { api, timeAgo } from "@/lib/api";
import { useAuth } from "@/App";

export default function ReadDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user, login } = useAuth();
  const [a, setA] = useState(null);

  useEffect(() => { api.get(`/articles/${id}`).then(r=>setA(r.data)).catch(()=>navigate("/reads")); }, [id]); // eslint-disable-line

  if (!a) return <div><Navbar onShare={()=>login()} onTopic={()=>login()} /></div>;

  return (
    <div>
      <Navbar onShare={()=>{ if(!user){login();return;} }} onTopic={()=>{ if(!user){login();return;} }} />
      <div className="article-detail">
        <button className="back" onClick={()=>navigate("/reads")}>← Back to Reads</button>
        {a.cover_image && (
          <div className="article-cover" style={{backgroundImage:`url("${a.cover_image}")`}}/>
        )}
        <div className="art-tag" style={{color:"#C47E2B",fontSize:11,letterSpacing:2,fontWeight:700,textTransform:"uppercase"}}>{a.tag}</div>
        <h1>{a.title}</h1>
        <div className="ad-meta">{a.author} · {timeAgo(a.created_at)}</div>
        <div className="ad-body">{a.body}</div>
      </div>
    </div>
  );
}
